// Vendor libraries
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
// Modules
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { MetricSelectorModalModule } from 'CalculationsApp/ts/features/metric-selector-modal/metric-selector-modal.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class KeyStatsModalModule {
}
KeyStatsModalModule.ɵfac = function KeyStatsModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || KeyStatsModalModule)(); };
KeyStatsModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: KeyStatsModalModule });
KeyStatsModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        CommonModule,
        ConfigModule,
        FeatureNeededModule,
        IconModule,
        MetricSelectorModalModule,
        ModalBaseModule,
        TooltipModule] });
